// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compt.compt-modal {
  display: flex;
  align-items: center;
  color: var(--app-main);
  font-size: 18px;
  font-weight: 500;
}
.compt.compt-modal .hpt-icon {
  margin-right: 15px;
  font-size: 26px;
}
.compt.compt-modal .close-btn {
  position: absolute;
  top: 6px;
  right: 6px;
}
.compt.compt-page {
  color: var(--app-mid-dark);
  font-size: 21px;
  font-weight: 600;
}
.compt.compt-page.fz-24 {
  font-size: 24px;
}
.compt.compt-page.fz-26 {
  font-size: 26px;
}
.compt.compt-page.fw500, .compt.compt-page.fw-500 {
  font-weight: 500;
}
.compt.compt-page.mid {
  color: var(--app-mid);
}
.compt.compt-page-t2 {
  color: var(--app-mid-dark);
  font-size: 21px;
  font-weight: 600;
}
.compt.compt-page-t2 .lbl-2 {
  color: var(--app-main);
}
.compt.compt-page-t2.fw-500 {
  font-weight: 500;
}
.compt.compt-page-t2.fz-18 {
  font-size: 18px;
}
.compt.compt-page-t2.mid .lbl {
  color: var(--app-mid);
}`, "",{"version":3,"sources":["webpack://./src/app/components/desktop/page-title/page-title.component.scss"],"names":[],"mappings":"AAWC;EACC,aAAA;EACA,mBAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;AAXF;AAaE;EACC,kBAAA;EACA,eAAA;AAXH;AAeQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AAbZ;AAmBC;EACC,0BAAA;EACA,eAAA;EACA,gBAAA;AAjBF;AAmBE;EACC,eAAA;AAjBH;AAmBE;EACC,eAAA;AAjBH;AAoBE;EAEC,gBAAA;AAnBH;AAsBE;EACC,qBAAA;AApBH;AAyBC;EACC,0BAAA;EACA,eAAA;EACA,gBAAA;AAvBF;AAyBE;EACC,sBAAA;AAvBH;AA0BE;EACC,gBAAA;AAxBH;AA0BE;EACC,eAAA;AAxBH;AA4BG;EACC,qBAAA;AA1BJ","sourcesContent":["//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------\n\n\n//@import \"../../../../theme/desktop\";\n\n\n\n\n\n.compt {\n\n\t&.compt-modal {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\tcolor: var(--app-main);\n\t\tfont-size: 18px;\n\t\tfont-weight: 500;\n\n\t\t.hpt-icon {\n\t\t\tmargin-right: 15px;\n\t\t\tfont-size: 26px;\n\t\t}\n\n        // Aggiunta Vigo\n        .close-btn{\n            position: absolute;\n            top: 6px;\n            right: 6px;\n        }\n        // Fine aggiunta Vigo\n\t}\n\n\n\t&.compt-page {\n\t\tcolor: var(--app-mid-dark);\n\t\tfont-size: 21px;\n\t\tfont-weight: 600;\n\n\t\t&.fz-24 {\n\t\t\tfont-size: 24px;\n\t\t}\n\t\t&.fz-26 {\n\t\t\tfont-size: 26px;\n\t\t}\n\n\t\t&.fw500,\n\t\t&.fw-500 {\n\t\t\tfont-weight: 500;\n\t\t}\n\n\t\t&.mid {\n\t\t\tcolor: var(--app-mid);\n\t\t}\n\t}\n\n\n\t&.compt-page-t2 {\n\t\tcolor: var(--app-mid-dark);\n\t\tfont-size: 21px;\n\t\tfont-weight: 600;\n\n\t\t.lbl-2 {\n\t\t\tcolor: var(--app-main);\n\t\t}\n\n\t\t&.fw-500 {\n\t\t\tfont-weight: 500;\n\t\t}\n\t\t&.fz-18 {\n\t\t\tfont-size: 18px;\n\t\t}\n\n\t\t&.mid {\n\t\t\t.lbl {\n\t\t\t\tcolor: var(--app-mid);\n\t\t\t}\n\t\t}\n\n\t}\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
